import { Outlet, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import IncidencesTableWithFilters from 'modules/bookkeepers/components/IncidencesTableWithFilters'

const IncidencesPage = () => {
  const { id } = useParams()
  const selectedIncidenceId = id ? +id : null

  return (
    <Box width="full" background="grey000White" alignItems="flexStart" gap="s24" padding="s24">
      <IncidencesTableWithFilters
        incidenceDetail={<Outlet />}
        selectedIncidenceId={selectedIncidenceId}
      />
    </Box>
  )
}

export default IncidencesPage
